import React, { useState, useEffect } from "react";
import ButtonComponent from "../shared/button/button.component";
import { LiveChatService } from '../../services/channels/LiveChatService';
import { DisabledGridIcon, FaceBookIcon, LiveChatByFalkonSystemsIcon, LiveChatMailIcon, LiveChatMinimizeIcon, LiveChatNotValidatedIcon, LiveChatUserIcon, LivechatDisconnectedIcon, LivechatValidationPendingIcon, MessageDeliveredIcon, WhatsAppIcon } from "../../icon";
import { LiveChatStatus } from "../../models/conversations";
import AnimateLoaderComponent from "../shared/loaders/animate-loader.component";
import LiveChatLoader from "../shared/loaders/live-chat-loader.json";
import { validateForm } from "../shared/form-validation";
import { generateSlug } from 'random-word-slugs';
import Avatar from "../shared/avatar.component";
import { FormHelperText, InputAdornment, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';
import { ChannelType, VisitorLoginType, WidgetTitle } from "../../models/channels/channels.model";
import LiveChatPageHeaderComponent from "./live-chat-popup-page-header.component";
import DisplayChannelConversation from "./live-chat-display-conversation";
import { MessageType } from "../../models/media.models";
import livechatPageLoader from "../shared/loaders/live-chat-page-loader.json";



interface IProps {
    ChannelId: string;
    Title: string;
    DeviceId: string;
    HandleUserData: (userId, latestSession, isLogedUser, sounds) => void;
    ChannelStatus: LiveChatStatus;
    Icon?: string;
    IsMobile: boolean;
    ValidatedUrl: string;
    IsShareToChatLink?: boolean;
    IsOrgnizationActive: boolean;
    LiveChatTheme: string;
    FaceBookUrl?: string;
    WhatsappUrl?: string;
    VisitorLoginType: number;
    CustomLoginFeilds: any[];
    FalkonBranding: boolean;
    WidgetType?: number;
    WelcomeMessage?: string;
    HeaderTextColor: string;
}

const LiveChatPopUp: React.FC<IProps> = (props: IProps) => {
    const IsMobileDevice = useSelector(selector.isMobileDevice)

    const [userName, setUserName] = useState<string>("")
    const [email, setEmail] = useState<string>("")
    const [errors, setErrors] = useState<{ name: string, email: string }>({ name: "", email: "" })
    const [customFields, setCustomFields] = useState<{
        field_name: string,
        field_type: "Text" | "Number",
        field_value: any,
        isRequired: boolean,
        error: string
    }[]>(props.CustomLoginFeilds.map(x => { return { ...x, field_value: "", error: "" } }))
    const [isExpanded, setIsExpanded] = useState(false);
    const [pageLoader, setPageLoader] = useState<boolean>(false);

    useEffect(() => {
        setTimeout(() => {
            setIsExpanded(true);
        }, 1);
    }, []);


    const LoginDetails = () => {
        let errors = { name: "", email: "" }
        validateForm({ email: email.trim(), name: userName.trim() },
            (Errors) => {
                errors = ({ ...errors, ...Errors });
            })
        if (!!errors.email || !!errors.name) {
            setErrors(errors)
        }
        if (customFields.find(x => x.isRequired && !x.field_value.length)) {
            setCustomFields(customFields.map(x => { return (x.isRequired && !x.field_value.length) ? { ...x, error: "Required feild cannot be empty" } : x }))
        }
        if (!errors.email && !errors.name && !customFields.find(x => x.isRequired && !x.field_value.length)) {
            setPageLoader(true)
            setIsExpanded(false);
            LiveChatService.sendLiveChatLoginUserDetails(props.ChannelId, {
                name: userName.trim(), username: email.trim(), data: {
                    device_id: props.DeviceId
                }, custom_fields: customFields.map(x => { return { field_name: x.field_name, value: x.field_value } })
            }).then((res) => {
                setTimeout(() => {
                    setPageLoader(false)
                    props.HandleUserData(res.data.id, new Date(res.data.latest_session).getTime(), true, res.data.sound_enabled)
                }, 10);
            }).catch(err => { })
        }
    }

    const AnonymousUser = () => {
        setIsExpanded(false);
        setPageLoader(true)
        LiveChatService.AnonymousUserDetails(props.ChannelId, {
            data: {
                device_id: props.DeviceId
            },
            nick_name: generateSlug(2, {
                format: "title",
                partsOfSpeech: ["adjective", "noun"],
                categories: {
                    adjective: ["personality"],
                    noun: ["food"]
                }
            })
        }).then((res) => {
            setTimeout(() => {
                props.HandleUserData(res.data.id, new Date(res.data.latest_session).getTime(), false, res.data.sound_enabled)
                setPageLoader(false)
            }, 10);
        }).catch(err => { })
    }

    const handleUserName = (e) => {
        validateForm({ name: e.target.value },
            (Errors) => {
                setErrors({ ...errors, ...Errors });
            })
        setUserName(e.target.value)
    }

    const handleEmail = (e) => {
        validateForm({ email: e.target.value },
            (Errors) => {
                setErrors({ ...errors, ...Errors });
            })
        setEmail(e.target.value)
    }

    const handleCloseWidget = () => {
        window.parent.postMessage({ action: 'callParentFunction', message: 'Hello from iframe!' }, "*");
    }

    const handleCustomFieldsChange = (e, name) => {
        setCustomFields(customFields.map(x => { return x.field_name === name ? { ...x, field_value: e.target.value, error: e.target.value.length ? "" : "Required feild cannot be empty" } : x }))
    }

    const handleToOpen = (url?: string) => {
        window.open(url, '_blank')
    }


    return (
        <div className={` ${props.IsShareToChatLink && !props.IsMobile ? `${IsMobileDevice ? "" : "w-v-60"} h-p-100 m-auto box-shadow-live-chat-pop-up` : "w-p-100  h-p-100"} d-flex flex-direction bg-color-live-chat-widget-hist-background`}>
            {/* {(props.IsShareToChatLink && !props.IsMobile)
                ?
                <div className={`${props.IsMobile ? "h-p-22" : " h-p-16"} color-secondary d-flex flex-direction color-secondary  `}>
                    <div className={`h-p-100 live-chat-header d-flex flex-direction align-center justify-center`}>
                        <div className={`w-p-100 min-w-10 d-flex justify-center`}>
                            <Avatar ImgSrc={!!props.Icon ? props.Icon : ""} Name={props.Title} Size={60} Status={props.IsOrgnizationActive ? "online" : "offline"} StatusPosition={{ top: "4px", right: 0 }} />
                        </div>
                        <div className={`w-space ${props.HeaderTextColor === "#ODODOD" ? "color-primary-accent" : "color-secondary"}`}>
                            {props.Title}
                        </div>
                    </div>
                </div>
                :
                <div className={`${props.IsMobile ? "min-h-9 h-p-12" : " h-p-12 min-h-9"} color-secondary d-flex flex-direction color-secondary`} style={{ borderRadius: "0 0 48px 0" }}>
                    <div className={` h-p-100 live-chat-header d-flex align-center`}>

                        {props.WidgetType === WidgetTitle.NAME_AND_LOGO && <div className={`${props.IsMobile ? "h-p-40" : ""} d-flex justify-center ml-2`}>
                            <div className={`w-p-100 d-flex justify-center align-center`}>
                                <Avatar ImgSrc={!!props.Icon ? props.Icon : ""} Name={props.Title} className={` d-flex justify-center align-center`} Size={50} />
                            </div>
                        </div>
                        }
                        <div className={` w-p-100 d-flex align-center ${props.WidgetType === WidgetTitle.NAME_AND_LOGO ? "ml-2" : "ml-4"}`}>
                            <div className={`w-p-100 h-p-100 d-flex flex-direction ${props.IsMobile ? "r-h1" : "new-live-chat-header"}  ${props.HeaderTextColor === "#ODODOD" ? "color-primary-accent" : "color-secondary"} `}>
                                <div className="w-space">
                                    {`${props.Title.length > (props.IsMobile ? 27 : 21) ? props.Title.slice(0, (props.IsMobile ? 24 : 18)) + "..." : props.Title}`}
                                </div>
                                {props.IsOrgnizationActive ?
                                    <div className={`br-2 d-flex align-center  r-h6-regular`}>
                                        <MessageDeliveredIcon className={"mr-1"} />
                                        Online
                                    </div>
                                    :
                                    <div className={`br-2 d-flex align-center r-h6-regular`}>
                                        <DisabledGridIcon className={"mr-1"} />
                                        Offline
                                    </div>
                                }
                            </div>
                        </div>
                        <div className=" d-flex  ml-auto mr-3">
                            <LiveChatMinimizeIcon width={20} height={20} className={"c-pointer"} onClick={handleCloseWidget} />
                        </div>
                    </div>
                </div>
            } */}

            <LiveChatPageHeaderComponent Title={props.Title} Icon={props.Icon} IsMobile={props.IsMobile} ValidatedUrl={props.ValidatedUrl} IsShareToChatLink={props.IsShareToChatLink} Status="online" IsOrgnizationActive={props.IsOrgnizationActive} LivechatTheme={props.LiveChatTheme} WidgetType={props.WidgetType} HeaderTextColor={props.HeaderTextColor} IsLoginComponent={true} SetShowEmojis={handleCloseWidget} FaceBookUrl={props.FaceBookUrl} WhatsappUrl={props.WhatsappUrl} />

            {pageLoader ?
                <AnimateLoaderComponent LoaderAnimation={livechatPageLoader} className="h-p-80 w-p-100" />
                :
                <>

                    {!!props.ChannelStatus ?

                        props.ChannelStatus === LiveChatStatus.CONNECTED ?

                            <div className={`min-h-20 bg-color-live-chat-widget-hist-background o-hidden flex-1 p-relative`}>
                                {props.VisitorLoginType !== VisitorLoginType.ALLOW_ANONYMOUS_LOGIN_ONLY &&
                                    <div className={` w-p-100 h-p-100 d-flex flex-direction align-center justify-center o-y-scroll`}>
                                        <div className="w-p-100 content-color h-p-94"  >
                                            {props.WelcomeMessage &&
                                                <div className={`d-flex ml-2 align-end animate1 ${isExpanded ? "expanded" : ""}`}>
                                                    {props.WidgetType === WidgetTitle.NAME_AND_LOGO && <div className={` d-flex justify-end `}>
                                                        <div className={`w-p-100 d-flex justify-center align-center`}>
                                                            <Avatar ImgSrc={!!props.Icon ? props.Icon : ""} Name={props.Title} className={` d-flex justify-center align-center`} Size={24} />
                                                        </div>
                                                    </div>
                                                    }
                                                    <div className="live-chat-inboundmsg bg-color-secondary r-h4-regular t-align-left float-left p-1 mt-2 ml-1 w-p-60 w-break w-fill">
                                                        {props?.WelcomeMessage}
                                                    </div>
                                                </div>
                                            }
                                            <div className={` ${(!props.IsMobile && props.IsShareToChatLink) ? "w-p-70" : "w-p-70"} mx-auto br-3 live-chat-button d-flex flex-direction  ${!!customFields?.length && props.VisitorLoginType === VisitorLoginType.ALLOW_LOGIN_ONLY ? "" : "justify-between"} animate1 ${isExpanded ? "expanded" : ""} bg-color-secondary py-2 px-2 mt-2`}>
                                                <div className={` max-h-6 min-h-3 r-h6-regular   mx-auto color-primary-accent w-p-100 d-flex align-center`}>
                                                    Name*
                                                </div>
                                                <TextField className={` max-h-10 min-h-3 ${(!props.IsMobile && props.IsShareToChatLink) ? "" : ""} bg-color-secondary br-1 d-flex justify-center w-p-100`}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            '& fieldset': {
                                                                border: '2px solid #E9E9E9',
                                                            },
                                                        }
                                                    }}
                                                    placeholder="first and lastname"
                                                    value={userName}
                                                    size={props.IsShareToChatLink ? "medium" : "small"}
                                                    onChange={handleUserName}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: "#013EEF",
                                                            textAlign: "center"
                                                        }
                                                    }}
                                                    InputProps={{
                                                        classes: { input: "r-h4-regular" }
                                                    }}
                                                    error={!!errors.name}
                                                />
                                                <FormHelperText className={` max-h-2 min-h-2 m-0 color-primary-danger t-align-right mx-auto r-h6-regular w-p-100`}>
                                                    {errors.name}
                                                </FormHelperText>
                                                <div className={` max-h-6 min-h-3 r-h6-regular   mx-auto color-primary-accent w-p-100 d-flex align-center`}>
                                                    Email*
                                                </div>
                                                <TextField className={` max-h-10 min-h-1 bg-color-secondary br-1 d-flex justify-center m-0 w-p-100`}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            '& fieldset': {
                                                                border: '2px solid #E9E9E9',
                                                            },
                                                        }
                                                    }}
                                                    placeholder="example@mail.in"
                                                    value={email}
                                                    size={props.IsShareToChatLink ? "medium" : "small"}
                                                    onChange={handleEmail}
                                                    error={!!errors.email}
                                                    InputProps={{
                                                        classes: { input: "r-h4-regular" }
                                                    }}
                                                />
                                                <FormHelperText className={` max-h-2 min-h-2 m-0 color-primary-danger t-align-right mx-auto r-h6-regular w-p-100`}>
                                                    {errors.email}
                                                </FormHelperText>
                                                {
                                                    customFields.map(x => {
                                                        return (
                                                            x.field_name === "Text" ?
                                                                <>
                                                                    <div className={` max-h-6 min-h-3 r-h6-regular   mx-auto color-primary-accent w-p-100 d-flex align-center`}>
                                                                        {x.field_name}{x.isRequired ? "*" : ""}
                                                                    </div>
                                                                    <TextField className={` max-h-10 min-h-1 bg-color-secondary br-1 d-flex justify-center m-0 w-p-100`}
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-root': {
                                                                                '& fieldset': {
                                                                                    border: '2px solid #E9E9E9',
                                                                                },
                                                                            }
                                                                        }}
                                                                        placeholder={`Enter ${x.field_name}`}
                                                                        value={x.field_value}
                                                                        size={props.IsShareToChatLink ? "medium" : "small"}
                                                                        InputProps={{
                                                                            classes: { input: "r-h4-regular" }
                                                                        }}
                                                                        type="text"
                                                                        onChange={(e) => { handleCustomFieldsChange(e, x.field_name) }}
                                                                        error={!!x.error.length}
                                                                    />
                                                                    <FormHelperText className={` max-h-2 min-h-2 m-0 color-primary-danger t-align-right mx-auto r-h6-regular w-p-100`}>
                                                                        {x.error}
                                                                    </FormHelperText>
                                                                </>
                                                                :
                                                                <>
                                                                    <div className={` max-h-6 min-h-3 r-h6-regular   mx-auto color-primary-accent w-p-100 d-flex align-center`}>
                                                                        {x.field_name}{x.isRequired ? "*" : ""}
                                                                    </div>
                                                                    <TextField className={` max-h-10 min-h-1 bg-color-secondary br-1 d-flex justify-center m-0 w-p-100`}
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-root': {
                                                                                '& fieldset': {
                                                                                    border: '2px solid #E9E9E9',
                                                                                },
                                                                            }
                                                                        }}
                                                                        placeholder={`Enter ${x.field_name}`}
                                                                        value={x.field_value}
                                                                        size={props.IsShareToChatLink ? "medium" : "small"}
                                                                        InputProps={{
                                                                            classes: { input: "r-h4-regular" }
                                                                        }}
                                                                        type="number"
                                                                        onChange={(e) => { handleCustomFieldsChange(e, x.field_name) }}
                                                                        error={!!x.error.length}
                                                                    />
                                                                    <FormHelperText className={` max-h-2 min-h-2 m-0 color-primary-danger t-align-right mx-auto r-h6-regular w-p-100`}>
                                                                        {x.error}
                                                                    </FormHelperText>
                                                                </>
                                                        )
                                                    })
                                                }
                                                <div className={`min-h-5 max-h-5 box-shadow-live-chat-input live-chat-anonymous br-1 color-secondary  d-flex justify-center align-center c-pointer mt-1`} onClick={LoginDetails} style={{ background: props.LiveChatTheme }}>Chat</div>
                                                {props.VisitorLoginType === VisitorLoginType.ALLOW_LOGIN_AND_ANONYMOUS_LOGIN &&
                                                    <>
                                                        {props.VisitorLoginType === VisitorLoginType.ALLOW_LOGIN_AND_ANONYMOUS_LOGIN && <div className={`min-h-5 max-h-5 color-live-chat-anonymous h6-medium text-between-line br-1 d-flex justify-center align-center c-pointer`}>or</div>}
                                                        <div className={`min-h-5 max-h-5 h5-medium br-1 color-primary-light d-flex justify-center align-center c-pointer color-live-chat-anonymous f-link-hover`} onClick={AnonymousUser} >
                                                            Continue as Guest
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }


                                {props.VisitorLoginType === VisitorLoginType.ALLOW_ANONYMOUS_LOGIN_ONLY &&
                                    <div className={`w-p-100 mx-auto live-chat-button d-flex flex-direction justify-between animate1 ${isExpanded ? "expanded" : ""}`}>
                                        <div className={`bg-color-live-chat-widget-hist-background`}>
                                            <div className=" d-flex ml-2 align-end">
                                                {props.WidgetType === WidgetTitle.NAME_AND_LOGO && <div className={` d-flex justify-end `}>
                                                    <div className={`w-p-100 d-flex justify-center align-center`}>
                                                        <Avatar ImgSrc={!!props.Icon ? props.Icon : ""} Name={props.Title} className={` d-flex justify-center align-center`} Size={30} />
                                                    </div>
                                                </div>
                                                }
                                                <div className="live-chat-inboundmsg bg-color-secondary h5-medium t-align-left float-left p-1 mt-2 ml-1 w-p-60 w-break w-fill">
                                                    {props?.WelcomeMessage}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            : props.ChannelStatus === LiveChatStatus.VALIDATION_PENDING ?
                                <div className={`${props.IsMobile ? "h-p-70" : props.IsShareToChatLink ? "h-p-76" : ""} d-flex bg-color-live-chat-widget-hist-background flex-1 justify-center align-center flex-direction bg-color-secondary`}>
                                    {(!!props.WhatsappUrl || !!props.FaceBookUrl) && <div className="d-flex align-center color-live-chat-anonymous py-2 ml-1 h-p-5">
                                        <div className={`ml-2  ${props.IsMobile ? "r-h4-medium" : "r-h6-medium"}`}>Connect with</div>
                                        {!!props.FaceBookUrl && <FaceBookIcon width={props.IsMobile ? 35 : 20} height={props.IsMobile ? 35 : 20} className={`${props.IsMobile ? "mx-2" : "mx-1"} c-pointer`} onClick={() => handleToOpen(props.FaceBookUrl)} />}
                                        {!!props.WhatsappUrl && <WhatsAppIcon width={props.IsMobile ? 35 : 20} height={props.IsMobile ? 35 : 20} onClick={() => handleToOpen(props.WhatsappUrl)} className="c-pointer" />}
                                    </div>
                                    }
                                    {(!!props.WhatsappUrl || !!props.FaceBookUrl) && <div className="bb-primary-divider-2 w-p-90 mx-auto"></div>}
                                    <div className={`${(!!props.WhatsappUrl || !!props.FaceBookUrl) ? "h-p-84" : "h-p-90"} w-p-94 d-flex flex-direction align-center justify-center mx-auto`}>
                                        <div className="h-p-50 d-flex justify-center mt-3 mb-3">
                                            <LivechatValidationPendingIcon />
                                        </div>
                                        <div className="h-p-8 d-flex justify-center align-center live-chat-conversation-header color-primary-light">The Live Chat's validation</div>
                                        <div className="h-p-8 d-flex justify-center align-center live-chat-conversation-header mb-3 color-primary-light">process is still pending.</div>
                                        <div className={`h-p-25 d-flex flex-direction live-chat-anonymous color-live-chat-anonymous`}>
                                            <div className="h-p-18 d-flex justify-center align-center mb-1">To establish the connection and start receiving</div>
                                            <div className="h-p-18 d-flex justify-center align-center mb-1">messages from visitors, please complete the</div>
                                            <div className="h-p-18 d-flex justify-center align-center">validation.</div>
                                        </div>
                                    </div>
                                </div>
                                : props.ChannelStatus === LiveChatStatus.DISCONNECTED &&
                                <div className={`${props.IsMobile ? "h-p-70" : props.IsShareToChatLink ? "h-p-76" : ""} d-flex flex-1  bg-color-live-chat-widget-hist-background justify-center align-center  flex-direction bg-color-secondary`}>
                                    {(!!props.WhatsappUrl || !!props.FaceBookUrl) && <div className="d-flex align-center color-live-chat-anonymous py-2 ml-1 h-p-5">
                                        <div className={`ml-2  ${props.IsMobile ? "r-h4-medium" : "r-h6-medium"}`}>Connect with</div>
                                        {!!props.FaceBookUrl && <FaceBookIcon width={props.IsMobile ? 35 : 20} height={props.IsMobile ? 35 : 20} className={`${props.IsMobile ? "mx-2" : "mx-1"} c-pointer`} onClick={() => handleToOpen(props.FaceBookUrl)} />}
                                        {!!props.WhatsappUrl && <WhatsAppIcon width={props.IsMobile ? 35 : 20} height={props.IsMobile ? 35 : 20} onClick={() => handleToOpen(props.WhatsappUrl)} className="c-pointer" />}
                                    </div>
                                    }
                                    {(!!props.WhatsappUrl || !!props.FaceBookUrl) && <div className="bb-primary-divider-2 w-p-90 mx-auto"></div>}

                                    <div className={`${(!!props.WhatsappUrl || !!props.FaceBookUrl) ? "h-p-84" : "h-p-90"} w-p-94 d-flex flex-direction align-center justify-center mx-auto`}>
                                        <div className="h-p-50 d-flex justify-center mt-3 mb-3">
                                            <LivechatDisconnectedIcon />
                                        </div>
                                        <div className="h-p-8 d-flex justify-center align-center live-chat-conversation-header color-primary-danger">The Live Chat Service</div>
                                        <div className="h-p-8 d-flex justify-center align-center live-chat-conversation-header mb-3 color-primary-danger">has been disconnected.</div>
                                        <div className="h-p-25 d-flex flex-direction  live-chat-anonymous color-live-chat-anonymous">
                                            <div className="h-p-18 d-flex justify-center align-center mb-1">Please use other ways of communication to</div>
                                            <div className="h-p-18 d-flex justify-center align-center mb-1">Contact Us.</div>
                                            <div className="h-p-18 d-flex justify-center align-center">Sorry,for the inconvineince.</div>
                                        </div>
                                    </div>
                                </div>

                        :
                        <div className={`${props.IsMobile ? "h-p-66" : "h-p-64"} d-flex align-center justify-center`}>
                            <div className="h-p-94 w-p-94 d-flex flex-direction align-center justify-center bg-color-live-chat-input br-2">
                                <AnimateLoaderComponent LoaderAnimation={LiveChatLoader} className={"w-p-100"} />
                            </div>
                        </div>
                    }

                    <div className={`w-p-100 d-flex justify-center flex-direction align-center bg-color-secondary animate1 ${isExpanded ? "expanded" : ""}`} >
                        {props.VisitorLoginType === VisitorLoginType.ALLOW_ANONYMOUS_LOGIN_ONLY &&
                            <div className={` w-p-100 d-flex align-center pt-2 bg-color-secondary ${props.FalkonBranding ? "" : "pb-2"}`}>
                                <div className={`w-p-74 min-h-5 max-h-5 box-shadow-live-chat-input h5-medium br-1 color-secondary m-auto d-flex align-center  justify-center c-pointer`} style={{ background: props?.LiveChatTheme }} onClick={AnonymousUser}>
                                    {"Chat"}
                                </div>
                            </div>
                        }
                        {props.FalkonBranding && <div className="d-flex w-p-100 min-h-6 justify-center align-center">
                            <LiveChatByFalkonSystemsIcon className={"w-2 h-2"} />
                            <span className="d-flex align-center justify-center h-p-100 live-chat-footer color-live-chat-anonymous">&nbsp;Powered by&nbsp;&nbsp;<a href="https://www.falkonsystems.com/" target="_blank" style={{ color: "#3663ff", textDecoration: "none" }}>Falkon Systems</a>
                                &nbsp;&&nbsp;<a href="https://www.falkonsms.com/" target="_blank" style={{ color: "#3663ff", textDecoration: "none" }}>Falkon SMS</a>
                            </span>
                        </div>
                        }
                    </div>
                </>
            }
        </div >
    )
}

export default LiveChatPopUp;
